import {Component, Input, OnInit} from '@angular/core';
import {NavController} from '@ionic/angular';
import {TeamModel} from 'src/app/models/team.model';
import {GlobalService} from 'src/app/services/global/global.service';
import {TeamService} from 'src/app/services/team/team.service';
import {ApiResponse} from 'src/app/services/utils';

@Component({
    selector: 'app-request-list',
    templateUrl: './request-list.component.html',
    styleUrls: ['./request-list.component.scss'],
    standalone: false
})
export class RequestListComponent implements OnInit {

  @Input() request: any;
  @Input() impactscore = '';

  requestFlag = true;

  constructor(
    private navController: NavController,
    private globalSerivce: GlobalService,
    private teamService: TeamService
  ) {
  }

  ngOnInit() {
  }

  acceptJoinRequest(teamId, userId) {
    const data = {teamId, userId};

    this.teamService.apiAcceptJoinRequest(data).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.requestFlag = false;
        this.globalSerivce.presentToast(result.message);
      }
    });
  }

  acceptJoinRequestCompany(teamId, companyId) {
    const data = {teamId, companyId};

    this.teamService.apiAcceptJoinRequest(data).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.requestFlag = false;
        this.globalSerivce.presentToast(result.message);
      }
    });
  }

  declineJoinRequestCompany(teamId, companyId) {
    const data = {teamId, companyId};

    this.teamService.apiDeclineJoinRequest(data).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.requestFlag = false;
        this.globalSerivce.presentToast(result.message);
      }
    });
  }

  declineJoinRequest(teamId, userId) {
    const data = {teamId, userId};

    this.teamService.apiDeclineJoinRequest(data).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.requestFlag = false;
        this.globalSerivce.presentToast(result.message);
      }
    });
  }

  openTeamDetail(t: TeamModel) {
    if (t.isAdmin) {
      this.navController.navigateForward(['/app/team/view-team/' + t.id]);
    } else {
      this.navController.navigateForward(['/app/team/other-team/' + t.id]);
    }
  }
}
